import { createSlice } from '@reduxjs/toolkit';
const location: any = {};
const filters: any = {};

const locationReducer = createSlice({
	name: 'locations',
	initialState: {
		isLoading: false,
		locations: [],
		location,
		filters,
	},
	reducers: {
		setLocationIsLoading: (state) => {
			state.isLoading = true;
		},
		resetLocationIsLoading: (state) => {
			state.isLoading = false;
		},
		setLocations: (state, action) => {
			state.locations = action.payload;
		},
		resetLocations: (state) => {
			state.locations = [];
		},
		setLocation: (state, action) => {
			state.location = action.payload;
		},

		resetLocation: (state) => {
			state.location = {};
		},

		setLocationFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetLocationFilters: (state) => {
			state.filters = {};
		},
	},
});
export const {
	setLocationIsLoading,
	resetLocationIsLoading,
	setLocation,
	resetLocation,
	setLocations,
	resetLocations,
	setLocationFilters,
	resetLocationFilters,
} = locationReducer.actions;
export default locationReducer.reducer;
